<div class="container" id="container">
    <div class="row">
        <div class="offset-lg-2 col-lg-8 offset-lg-2">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-header>
                    <mat-card-title> FAQ anlegen </mat-card-title>
                </mat-card-header>
                <mat-card-content [formGroup]="addForm">
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Frage:</mat-label>
                                <input matInput type="text" formControlName="title">
                                <mat-error *ngIf="addForm.get('title').hasError('required')">
                                    Frage <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <mat-form-field class="full-width">
                                <mat-label>Antwort:</mat-label>
                                <textarea  formControlName="description" matInput rows="8" cols="50"></textarea>
                                <mat-error *ngIf="addForm.get('description').hasError('required')">
                                    Antwort <strong>muss</strong> angegeben werden
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" [routerLink]="['/caseworker/faq']">Abbrechen</button>
                    <button mat-button color="primary" (click)="createFAQ()">FAQ-Eintrag Anlegen</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>